<page-load-header *ngIf="!initialized"></page-load-header>

<div class="row mb-3">
  <div class="col-md-6">
    <div class="dropdown"><h3>My Posters</h3></div>
  </div>
  <div class="col-md-6 text-right">
    <button class="btn btn-primary" type="button" tabindex="0" [routerLink]="['../call-for-posters']">Add a Poster</button>
  </div>
</div>
<div *ngIf="initialized">
  <div class="row no-gutters no-candidates" style="height: 300px;" *ngIf="posters && posters.length == 0">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>You don't have any posters.</h4>
      <p>Let's create one!</p>
      <a [routerLink]="['../call-for-posters']" class="btn btn-instagram">Add a Poster</a>
    </div>
  </div>

  <div class="card">
    <div class="card-body p-4" *ngIf="posters && posters.length > 0">
      <!-- Activity Table -->
      <div class="table-responsive-md u-datatable">
        <table class="js-datatable table table-borderless u-datatable__striped u-datatable__content u-datatable__trigger mb-5" data-dt-info="#datatableInfo" data-dt-search="#datatableSearch" data-dt-entries="#datatableEntries" data-dt-page-length="12" data-dt-is-responsive="false" data-dt-is-show-paging="true" data-dt-details-invoker=".js-datatabale-details" data-dt-select-all-control="#invoiceToggleAllCheckbox" data-dt-pagination="datatablePagination" data-dt-pagination-classes="pagination mb-0" data-dt-pagination-items-classes="page-item" data-dt-pagination-links-classes="page-link" data-dt-pagination-next-classes="page-item" data-dt-pagination-next-link-classes="page-link" data-dt-pagination-next-link-markup='<span aria-hidden="true">&raquo;</span>' data-dt-pagination-prev-classes="page-item" data-dt-pagination-prev-link-classes="page-link" data-dt-pagination-prev-link-markup='<span aria-hidden="true">&laquo;</span>'>
          <thead>
            <tr class="text-uppercase font-size-1">
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">
                  Title
                </div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">
                  Date
                </div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">
                  Time
                </div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">
                  Conference
                </div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">
                  Status
                </div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">
                  Actions
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="font-size-1">
            <tr *ngFor="let poster of posters">
              <td class="align-middle font-weight-normal">
                <a [routerLink]="[poster.id,'edit']">{{ poster.title }}</a>
              </td>
              <td class="align-middle text-secondary font-weight-normal">{{ poster.posterSessionDateTime | date: 'shortDate' }}</td>
              <td class="align-middle text-secondary font-weight-normal">{{ poster.posterSessionDateTime | date: 'shortTime' }}</td>
              <td class="align-middle">{{ poster.posterSessionConferenceName }}</td>
              <td class="align-middle">{{ poster.approved ? 'Approved': 'Pending' }}</td>
              <td class="align-middle text-danger">
                <div class="dropdown">
                  <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" [routerLink]="[poster.id,'edit']">Edit Details</a>
                    <a class="dropdown-item" [routerLink]="['/poster-session',poster.posterSessionId ,'posters', poster.id]">Preview</a>
                    <a class="dropdown-item" [routerLink]="['/poster-session',poster.posterSessionId ,'posters', poster.id, 'dashboard']">Poster Dashboard</a>
                    <!-- <a class="dropdown-item" href="#">Preview</a> -->
                    <!-- <div class="dropdown-divider"></div> -->
                    <!-- <a class="dropdown-item" [routerLink]="['.', poster.id, 'dashboard']">Poster Dashboard</a> -->
                    <!-- <div class="dropdown-divider"></div> -->
                    <!-- <a class="dropdown-item" href="#">Export Attendees</a> -->
                    <!-- <a class="dropdown-item" href="#">Export Chat History</a> -->
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- End Activity Table -->

      <!-- Pagination -->
      <div class="d-flex align-items-center">
        <nav id="datatablePagination" aria-label="Activity pagination"></nav>

        <small id="datatableInfo" class="text-secondary ml-auto"></small>
      </div>
      <!-- End Pagination -->
    </div>
  </div>
</div>
